import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { GenericService } from '../../../infrastructure/infrastructure-services/services/base/generic-service';
import { GenericEntryForm } from '../../../infrastructure/infrastructure-services/generics/genericentryform/generic-entry-form';
import { ActivatedRoute, Router } from '@angular/router';
import { enumFormModes, enumErrorMessageText } from '../../../infrastructure/infrastructure-services/common/common-enums';
import { mapper } from 'src/app/infrastructure/infrastructure-services/common/mapper';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenericCflViewComponent } from 'src/app/infrastructure/infrastructure-services/generics/generic-cfl-view/generic-cfl-view.component';
import { map, Observable, pipe, startWith } from 'rxjs';
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { WrapperStandardFilter } from 'src/app/infrastructure/infrastructure-services/common/models/wrapper.model';
import { DateAdapter } from '@angular/material/core';
import { GenericAttachmentUploadView } from 'src/app/infrastructure/infrastructure-services/generics/generic-attachment-upload/generic-attachment-upload-view';
import { GenericAutoCompleteView } from 'src/app/infrastructure/infrastructure-services/generics/generic-autocomplete-view/generic-autocomplete-view';
import { FormControl } from '@angular/forms';
import { BaseService } from 'src/app/infrastructure/infrastructure-services/services/base/base-service';
import { GlobalProperties } from 'src/app/global/global-properties';
import { Attachments2_LinesModel, DocumentLinesModel, DocumentLinesModelSAP, IjournalModel, IjournalModelSAP, JournalModel, JournalModelSAP } from 'src/app/core/models/masters/journal-master-model';
import { DataService } from 'src/app/shared/constants/data.service';
import { forEach } from 'lodash';
import { createMap, forMember, mapWith } from '@automapper/core';
import { DatePipe } from '@angular/common';

interface Series {
  code: string,
  name: string,
  bplid:number
}
interface Branch {
  branchName: string;
  bplid: number;
}

@Component({
  selector: 'app-journalentry-entry-form',
  templateUrl: './journalentry-entry-form.component.html',
  styleUrls: ['./journalentry-entry-form.component.css']
})
export class JournalentryEntryFormComponent extends GenericEntryForm<IjournalModel, IjournalModelSAP> {

  displayedColumns: string[] = ['account_code', 'account_name', 'control_account',
    'debit', 'credit', 'location', 'branch_name', 'rowNote', 'project', 'action']
  dataSource: any = [{}]
  setDisplayedColumnsNamesList: string[];
  apiString: any;
  selectedFile: any[] = [];
  selectedAttacment: any[] = [];
  series: any;
  debittotal=0;
  credittotal=0;
  debitdiff=0;
  creditdiff=0;
  genAutoComplete = new GenericAutoCompleteView<IjournalModel>(this.agenericRepositoryForCfl, this.routerForCfl);
  genAttachUpload = new GenericAttachmentUploadView<IjournalModel>(this.http);
  myControlSeries = new FormControl<string | Series>('');
  OptionSeries: Series[] = []
  filteredOptionsSeries!: Observable<Series[]>;
  name: any;
  selectedData: any;
  myControlBranch = new FormControl<string | Branch>('');
  OptionBranch: Branch[] = []
  filteredOptionsBranch!: Observable<Branch[]>;
  constructor(private http: HttpClient, agenericRepository: GenericService<IjournalModel>, private dateAdapter: DateAdapter<Date>, private activatedRoute: ActivatedRoute, router: Router,
     private activated: ActivatedRoute,

    public matDialogforCfl: MatDialog, public matDialogRefForCfl: MatDialogRef<GenericCflViewComponent<IjournalModel>>,
    @Inject(MAT_DIALOG_DATA) private data: any, dialog: MatDialog,
    public agenericRepositoryForCfl: GenericService<IjournalModel>,
    public snackbarService: BaseService<any>, public routerForCfl: Router, public dataService: DataService,
    private dbService: NgxIndexedDBService
  ) {
    super(agenericRepository, router, dialog);
    // this.setMenuCode = "M311";
    this.dateAdapter.setLocale('en-GB');

    this.setDisplayedColumnsNamesList = ['account_code', 'account_name', 'control_account', 'debit', 'credit', 'location', 'branch_name', 'rowNote', 'project', 'action'];
    //this.setDisplayedColumnsNamesList = ['itemCode', 'itemDescription'];
    localStorage.removeItem('Absolute');
    this.setListViewFormRouteTo = "/home/banking/journalentrylistview/";
    this.dataService.tableName = 'JournalEntry'
    //this.setEFModel = new accountEFModel();
    this.setRequestDataForFormModeNew = "";
    this.setURLForFormModeNew = "JournalEntries/NewJournalEntriesService";
    this.setURLForFormModeEdit = "JournalEntries/GetJournalEntriesService";
    this.setURLForFormModeAddSap = "JournalEntries";
    this.setURLForFormModeUpdateSap = `JournalEntries(${this.activatedRoute.snapshot.params['id']})`;

    let journal = new JournalModel();
    let journalSAP = new JournalModelSAP();
    // journal.code = this.activatedRoute.snapshot.params['id'];
    let id = this.activatedRoute.snapshot.params['id'];
     if (this.data?.id) 
        id=data.id.toString();
    this.setEntryFormDataSource = journal;
    this.setEntryFormDataSourceSAP = journalSAP;

    let documentlines = new DocumentLinesModel();
    this.getEntryFormDataSource.documentLines = [documentlines];

    if (id != "0") {

      // this.setRequestDataForFormModeEdit = chartofaccount.code;
      // console.log(chartofaccount.cashFlowRelevant);
      this.setRequestDataForFormModeEdit = id;
      this.setFormMode = enumFormModes.ModeEdit;
      this.setFormDisable = true;
    }
    else {
      this.setFormMode = enumFormModes.ModeNew;
      this.setFormDisable = false;
    }




    console.log('Here' + this.getEntryFormDataSource);

    this.PopulateEntryForm_V2()

  }
  async PopulateEntryForm_V2() {
    await this.PopulateEntryForm();
    await this.genAttachUpload.onAttachmentGetFiles(this.getEntryFormDataSource.attachmentEntry);
    this.getEntryFormDataSource.Attachments2_Lines = this.genAttachUpload.getAttactmentListData;
    this.getEntryFormDataSource.documentLines.forEach(el =>{ (el.accountCode  as any)= el.account; 
   } );
    // this.getEntryFormDataSource.bplId = Number(localStorage.getItem("BranchId"));
    // this.getEntryFormDataSource.branchName = String(localStorage.getItem("BranchName"));
    this.calculateTotal();
  }

  ngOnInit() {
    this.getIntialAPIListForBranch();
    this.getIntialAPIListForSeries();
    this.filteredOptionsSeries = this.myControlSeries.valueChanges.pipe(
      startWith(''),
      map(value => {
        const name = typeof value === 'string' ? value : value?.name;
        return name ? this._filterSeries(name as string) : this.OptionSeries.slice();
      }),
    );
  }

  async getIntialAPIListForBranch() {
    this.genAutoComplete.setACDataSourceURL = 'Branch/GetBranchListService';
    this.genAutoComplete.setACSortColumn = "bplid";
    let filter: WrapperStandardFilter = new WrapperStandardFilter();

  //   filter.Key = 'disabled';
  //   filter.OperatorType = 'contains';
  //   filter.Value = 'N'
  // this.genAutoComplete.setFilterArray=filter
    let result = await this.genAutoComplete.onClickOptionsList();
    // result=result.filter((element)=>{
    // })
    result.forEach((element: any) => {
      this.OptionBranch.push({ 'branchName': element.branchName, 'bplid': element.bplid });
    })
  }
  async getIntialAPIListForSeries() {
    this.genAutoComplete.setACDataSourceURL = 'DocumentNumberingSetup/GetDocumentNumberingSetupListService';
    this.genAutoComplete.setACSortColumn = "series";
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    this.genAutoComplete.setFilterArray=filter
    let result = await this.genAutoComplete.onClickOptionsList();
    result = result.filter((element) => {

        return element.document == '30' && element.locked == 'N';



    });
    result.forEach((element: any) => {
      this.OptionSeries.push({ 'name': element.name, 'code': element.series , 'bplid':element.bplid});
    })
    if(this.getFormMode== enumFormModes.ModeNew){
     this.getEntryFormDataSource.bplId = <any>localStorage.getItem('BranchId');
     this.getEntryFormDataSource.bplName = <any>localStorage.getItem('BranchName');}
    this.getEntryFormDataSource.documentLines[0].bplid = this.getEntryFormDataSource.bplId;
    this.getEntryFormDataSource.documentLines[0].bplName = this.getEntryFormDataSource.bplName;
  }

  private _filterSeries(name: string): Series[] {
    const filterValue = name.toLowerCase();
    return this.OptionSeries.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  OnOptionSelectedSeries(option: Series) {
    if (this.btnText == 'Language.OkText') {
      this.btnText = 'Language.UpdateText';
    }
    this.name = option;
    this.series = option ? option.code : null;
    //  this.getEntryFormDataSource.series = this.series;
    if (option.bplid==null){
      this.getEntryFormDataSource.bplName="";
      this.getEntryFormDataSource.bplId=0;
      return;
    }

this.getEntryFormDataSource.bplName=this.OptionBranch.filter(i=>{return i.bplid==option.bplid})[0].branchName;
this.getEntryFormDataSource.bplId=option.bplid;
  }

  override onClickOfGenericCancelButton(event: any) {
    if (this.data) {
      this.dialog.closeAll();
    } else {
      super.onClickOfGenericCancelButton(event);
    }
  }
  addRow() {
    let lineItem = new DocumentLinesModel();
    lineItem.bplid = this.getEntryFormDataSource.bplId;
    lineItem.bplName=this.getEntryFormDataSource.bplName;
    lineItem.locationCode=this.getEntryFormDataSource.locationCode;
    lineItem.projectCode=this.getEntryFormDataSource.projectCode;
    this.getEntryFormDataSource.documentLines.push(lineItem);
    this.getEntryFormDataSource.documentLines = [...this.getEntryFormDataSource.documentLines];
  }

  deleteRow(index: number) {
    this.getEntryFormDataSource.documentLines.splice(index, 1);
    this.getEntryFormDataSource.documentLines = [...this.getEntryFormDataSource.documentLines];

    // this.calculateTotals();
  }

  onOpenDropDown(value: any, index: number) {
    let filter: WrapperStandardFilter = new WrapperStandardFilter();
    let genCFL = new GenericCflViewComponent<IjournalModel>(this.agenericRepositoryForCfl, this.routerForCfl, this.matDialogforCfl, this.matDialogRefForCfl, this.data, this.dbService);
    if (value == 1) {
      genCFL.setCflTitle = "Branch";
      genCFL.setCflViewDataSourceURL = 'Branch/GetBranchListService';

      genCFL.setCflDisplayedColumnsNamesList = ['branchName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.bplId;
      genCFL.setSortColumn = "bplid";
      filter.Key = 'disabled';
      filter.OperatorType = 'contains';
      filter.Value = 'N'
      genCFL.setCflFilterArray = filter;
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          this.selectedData = res.event;
          this.getEntryFormDataSource.bplId = res.event.bplid;
          this.getEntryFormDataSource.bplName = res.event.branchName;

          for (var i = 0; i < this.getEntryFormDataSource.documentLines.length; i++) {
            this.getEntryFormDataSource.documentLines[i].bplName = res.event.branchName;
            this.getEntryFormDataSource.documentLines[i].bplid = res.event.bplid;
          }

          this.getEntryFormDataSource.seriesName=this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0]== undefined ?"":this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0].name;
          this.getEntryFormDataSource.series=this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0]== undefined?"0":this.OptionSeries.filter(i=>{return  i.bplid==res.event.bplid })[0].code;
                 
          
        }
      })
    }
    if (value == 6) {
      genCFL.setCflTitle = "Project";
      genCFL.setCflViewDataSourceURL = 'Project/GetProjectListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.selectedData;
      genCFL.setSortColumn = "name";
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          this.selectedData = res.event;
          this.getEntryFormDataSource.projectCode = res.event.code;

          for (var i = 0; i < this.getEntryFormDataSource.documentLines.length; i++) {
            this.getEntryFormDataSource.documentLines[i].projectCode = res.event.code;

          }
        }
      })
    }
    if (value == 3) {
      genCFL.setCflTitle = "Location";
      genCFL.setCflViewDataSourceURL = 'Location/GetLocationListService';
      genCFL.setCflDisplayedColumnsNamesList = ['name', 'city'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.locationCode;
      genCFL.setSortColumn = "name";
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          this.selectedData = res.event;

          this.getEntryFormDataSource.locationCode = res.event.code;
          this.getEntryFormDataSource.locationName = res.event.name;
          
          for (var i = 0; i < this.getEntryFormDataSource.documentLines.length; i++) {
            this.getEntryFormDataSource.documentLines[i].locationCode = res.event.code;
            this.getEntryFormDataSource.documentLines[i].locationName = res.event.name;
          }
        }
      })



    }
    if (value == "accounts") {

      genCFL.setCflTitle = "G/L Accounts";
      genCFL.setIsCflSingleSelection = true;
      genCFL.setCflViewDataSourceURL = 'ChartOfAccounts/GetChartOfAccountsListService';
      genCFL.setCflDisplayedColumnsNamesList = ['code', 'name'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.documentLines[index].accountCode;
      genCFL.setSortColumn = "name";
      filter.Key = 'activeAccount';
      filter.OperatorType = 'contains';
      filter.Value = 'Y'
      genCFL.setCflFilterArray = filter;

      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          this.selectedData = res.event;
          this.getEntryFormDataSource.documentLines[index].accountCode = res.event.code;
          this.getEntryFormDataSource.documentLines[index].accountName = res.event.name;
          this.getEntryFormDataSource.documentLines[index].shortName = res.event.code;
          this.getEntryFormDataSource.documentLines[index].controlAccount = res.event.code;
        }
      })
    }

    if (value == "businessPartner") {

      genCFL.setCflTitle = "Business Partners";
      genCFL.setCflViewDataSourceURL = 'BusinessPartner/GetBusinessPartnerListService';
      genCFL.setCflDisplayedColumnsNamesList = ['cardCode', 'cardName', 'groupName'];
      genCFL.setCflSelectedData = this.getEntryFormDataSource.documentLines[index].accountCode;
      genCFL.setCflFilterArray = {"Key": "CardType","Value": "","OperatorType": "contains"};
      genCFL.setSortColumn = "cardCode";

      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          this.getEntryFormDataSource.documentLines[index].accountCode = res.event.cardCode;
          this.getEntryFormDataSource.documentLines[index].shortName = res.event.cardCode;
         this.getEntryFormDataSource.documentLines[index].accountName = res.event.cardName;
         this.getEntryFormDataSource.documentLines[index].controlAccount=res.event.debPayAcct;
        }
      })
    }

    if (value == "chooseAccountType") {
      genCFL.setCflTitle = "Choose Account Type";
      genCFL.setIsItCflEnumList = true;
      genCFL.setCflEnumStoreName = 'AccountType';
      genCFL.setCflEnumDataToStoreInDB = {accountType: [{name: 'G/L Account', id: 1}, {name: 'Business Partner', id: 2}]};
      genCFL.setCflEnumObjectNameToDisplay = 'accountType';
      genCFL.setCflDisplayedColumnsNamesList = ['name'];
      genCFL.setSortColumn = "id";
      genCFL.openCFL(GenericCflViewComponent, {}).afterClosed().subscribe(res => {
        if (res != undefined && res.event != undefined) {
          if(res.event.id == 1) {
            this.onOpenDropDown("accounts", index);
          }else {
            this.onOpenDropDown("businessPartner", index);
          }
        }
      })
    }    

  }

  calculateTotal(){

    this.debittotal=0;
    this.credittotal=0;
    this.debitdiff=0;
    this.creditdiff=0;
    this.getEntryFormDataSource.documentLines.forEach((row)=>{
        this.debittotal+=row.debit;
        this.credittotal+=row.credit;

    });
    if(this.credittotal>this.debittotal){
      this.debitdiff= this.credittotal -this.debittotal;
     // this.creditdiff=
    }
    else if(this.debittotal>this.credittotal)
    {
    this.creditdiff=this.debittotal-this.credittotal;}
  }
  onValidate(): boolean {
    let lreturn: boolean = true;
    let value = [];
    let data: any = this.getEntryFormDataSource;

    data.referenceDate == null ? value.push(enumErrorMessageText.ReferenceDateEmptyStatus) : null;
    data.dueDate == null ? value.push(enumErrorMessageText.DueDateEmptyStatus) : null;
    data.taxDate == null ? value.push(enumErrorMessageText.TaxDateEmptyStatus) : null;
    data.bplName == null ? value.push(enumErrorMessageText.BranchNameEmptyStatus) : null;
   data.series==null?value.push(enumErrorMessageText.SeriesEmptyStatus) : null;
    data.documentLines.forEach(function (item: any) {
      // item.debit == null ? value.push(enumErrorMessageText.DebitEmptyStatus) : null;
      // item.credit == null ? value.push(enumErrorMessageText.DebitEmptyStatus) : null;
     (item.debit==null && item.credit==null)?
      value.push(enumErrorMessageText.DebitCreditEmptyStatus):null;
      item.accountCode ==null ? value.push(enumErrorMessageText.AccountCodeEmptyStatus): null;
    })

    this.showValidationArr = value
    if (this.showValidationArr.length != 0) {
      lreturn = false
    }
    return lreturn
  }

  onSave(aEvent: any) {
    if (this.btnText == 'Language.OkText') {
      this.routerForCfl.navigate([this.getListViewFormRouteTo]);
    }
    else {
      if (this.onValidate()) {
        var pipe = new DatePipe('en-US');        
        let dto = mapper.map(this.getEntryFormDataSource, JournalModel, JournalModelSAP);
        dto.ReferenceDate= pipe.transform(dto.ReferenceDate, 'y-MM-d');
        dto.DueDate= pipe.transform(dto.DueDate, 'y-MM-d');
        dto.TaxDate= pipe.transform(dto.TaxDate, 'y-MM-d');
        let journalEntries: DocumentLinesModelSAP[] = [];
        this.getEntryFormDataSource.documentLines.forEach(el => {
          let journalEntry = new DocumentLinesModelSAP();
          journalEntry.Line_ID = el.line_ID;
          journalEntry.Debit = el.debit;
          journalEntry.Credit = el.credit;
          journalEntry.BPLID = el.bplid;
          journalEntry.BPLName = el.bplName;
          journalEntry.AccountCode = el.accountCode;
          journalEntry.ReferenceDate1 = el.referenceDate1;
          journalEntry.DueDate = el.dueDate;
          journalEntry.TaxDate = el.taxDate;
          journalEntry.Reference1 = el.ref1;
          journalEntry.Reference2 = el.ref2;
          journalEntry.LineMemo = el.lineMemo;
          journalEntry.ControlAccount = el.controlAccount;
          journalEntry.LocationCode = el.locationCode;
          journalEntry.ProjectCode = el.projectCode;
          journalEntry.ShortName = el.shortName;
          journalEntries.push(journalEntry);
        })
        dto.JournalEntryLines = journalEntries;
        dto.AttachmentEntry = localStorage.getItem("Absolute");
        this.setEntryFormDataSourceSAP = dto;
        this.SaveEntryForm();
      }
      else {
        this.openDialog();
      }
    }
  }

   onSelectedFiles(event: any) {
      this.selectedFile.push(...Array.from(event.target.files))
      for (let i = 0; i < this.selectedFile.length; i++) {
        var _files = new Attachments2_LinesModel();
        _files.FileName = event.target.files[i].name;
        _files.FileExtension = event.target.files[i].name.split(".")[ event.target.files[i].name.split(".").length-1];
        this.getEntryFormDataSource.Attachments2_Lines.push(_files);
      }
      this.genAttachUpload.setSelectedFileList = {target: {files: this.selectedFile}};
      this.genAttachUpload.onSelectedFiles();
    }
    onUpload() {
      if(this.validateFileSize()) {
        this.genAttachUpload.onUploadFiles(this.getEntryFormDataSource.attachmentEntry);
      }else {
        this.openDialog();
      }
    }
  
    validateFileSize() {
      const maxFileSize = 5 * 1024 * 1024; // 5 MB in bytes
      const files = this.selectedFile;
      let errors: string[] = [];
  
      if(files.length > 10) {
        errors.push('You can only upload a maximum of 10 files.');
      }else {  
        files.forEach((el, i): any => {
          let file: any = files[i];
          if(file.size > maxFileSize) {
            errors.push(`File "${file.name}" exceeds the 5 MB size limit.`);
          }
        })
      }
  
      if(errors.length > 0) {
        this.showValidationArr = errors;
        return false;
      }else {
        return true;
      }
    }
  
    onAttachmentDelete(val: number) {
      this.selectedFile.splice(val,1);
      this.getEntryFormDataSource.Attachments2_Lines.splice(val,1);
      this.getEntryFormDataSource.Attachments2_Lines=[...this.getEntryFormDataSource.Attachments2_Lines];
      if (this.getEntryFormDataSource.attachmentEntry != null && this.getEntryFormDataSource.attachmentEntry != "" && this.getEntryFormDataSource.attachmentEntry != undefined) {
        this.genAttachUpload.onAttachmentDeleteFiles(this.getEntryFormDataSource.attachmentEntry, this.getEntryFormDataSource.Attachments2_Lines)
      }
    }
  
    viewImage(attachmentEntry: number, filePath = "") {
      window.open(`${GlobalProperties.getApiUrlSap}Attachments2(${attachmentEntry})/$value`, "_blank");
    }


}
